import React from "react";
import { Link, useLocation } from "react-router-dom";
import Seo from "../../components/Seo";
import Nav from "../../components/landing/Nav";
import { SITE } from "../../content/site";
import { langFromPath, routePath } from "../../lib/routes";

export default function NotFound() {
  const { pathname } = useLocation();
  const lang = langFromPath(pathname);
  const c = SITE[lang].notFound;
  return (
    <div className="min-h-screen bg-white">
      <Seo lang={lang} title={`404 — ${c.h1} | Equestrian Partners`} description={c.text} path={pathname} alternates={[]} noindex />
      <Nav solid />
      <div className="h-[60px] md:h-[68px]" />
      <main id="main" className="flex min-h-[60vh] flex-col items-center justify-center gap-4 px-6 text-center" data-testid="not-found-page">
        <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-[#0e7c6b]">404</p>
        <h1 className="font-display text-4xl font-light text-[#050505] sm:text-5xl">{c.h1}</h1>
        <p className="max-w-md text-base font-light text-[#6b6f6c]">{c.text}</p>
        <Link to={routePath("home", lang)} data-testid="notfound-home-link"
          className="mt-4 rounded-full bg-[#050505] px-7 py-3 text-sm font-medium text-white transition-opacity hover:opacity-85">{c.cta}</Link>
      </main>
    </div>
  );
}
